import {
  MEDIA_IMAGE_CONTENT_TYPES,
  MEDIA_VIDEO_CONTENT_TYPES,
  buildAcceptAttribute,
} from '@/constants/media';

export const ALLOWED_FILE_UPLOAD_CONTENT_TYPES = [
  ...MEDIA_IMAGE_CONTENT_TYPES,
  'application/pdf',
  ...MEDIA_VIDEO_CONTENT_TYPES,
];

export const ALLOWED_CLIENT_FILE_UPLOAD_CONTENT_TYPES = [
  ...MEDIA_IMAGE_CONTENT_TYPES,
  'application/pdf',
];

export const FILE_UPLOAD_ACCEPT_ATTRIBUTE = buildAcceptAttribute(ALLOWED_FILE_UPLOAD_CONTENT_TYPES);
export const CLIENT_FILE_UPLOAD_ACCEPT_ATTRIBUTE = buildAcceptAttribute(
  ALLOWED_CLIENT_FILE_UPLOAD_CONTENT_TYPES
);

export const MAXIMUM_FILE_UPLOAD_SIZE_BYTES = 100 * 1024 * 1024;

export const FILE_VISIBILITY = {
  therapistOnly: 'therapist_only',
  clientVisible: 'client_visible',
} as const;

export type FileVisibility = (typeof FILE_VISIBILITY)[keyof typeof FILE_VISIBILITY];

export const FILE_STATUS = {
  awaitingUpload: 'awaiting_upload',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;
